import { render, staticRenderFns } from "./DateFormItem.vue?vue&type=template&id=35a917b2&"
import script from "./DateFormItem.vue?vue&type=script&lang=js&"
export * from "./DateFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports